<div class="main-container" [class.open]="opened">
  <aside class="sidebar" [class.open]="opened">
    <app-sidebar></app-sidebar>
  </aside>
  <div class="main" [class.open]="opened">
    <header class="menu">
      <app-menu></app-menu>
    </header>
    <div class="contenter" #contentMain [class.open]="opened" [class.noPadding]="noPaddingMainContent" [@routeAnimations]>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
